import { SAVE_APPLICATION_DATA } from "../actions/application-data.type";
import { ApplicationDataState } from "../interfaces/application-data.interface";
import { applicationDataAction } from "../types/actions-reducer.type";

const applicationDataReducer = (state:ApplicationDataState, action:applicationDataAction) => {

    const { type, payload } = action;

    switch(type) {
        case SAVE_APPLICATION_DATA:
            return { ...state, ...payload }
        default:
            return state;
    }
}

export default applicationDataReducer;